import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentSettingsService {
  constructor(private http: HttpClient) {}

  getDomainGatewaySettings(gatewayCode: string, usingBaseFallback: boolean = true): Observable<DomainGatewaySettings> {
    return this.http.get<DomainGatewaySettings>(`payment/private/v2/gateways/${gatewayCode}/domain-settings`, {
      params: { usingBaseFallback: String(usingBaseFallback) }
    });
  }

  getDomainSettings(): Observable<DomainGatewaySettings> {
    return this.http
      .get<DomainGatewaySettings>(`payment/private/partner-admin/v2/gateways/stripe/domain-settings`)
      .pipe(map(res => Object.assign(new DomainGatewaySettings(), res)));
  }
}

export class DomainGatewaySettings {
  usingOwnAccount: boolean;
  publicKey: string;

  get isUsingOwnAccount(): boolean {
    return this.publicKey != null && this.publicKey.trim() !== '';
  }
}
